import React from 'react';
export default class Timer extends React.Component {
    constructor(props) {
        super(props);
        this.state = { seconds: 0 , minutes: 0 };
    }

    tick() {
        if (this.state.seconds === 59) {
            this.setState(state => ({
                minutes: state.minutes + 1
            }));
            this.setState(state => ({
                seconds: 0
            }));
        } else {
            this.setState(state => ({
                seconds: state.seconds + 1
            }));
        }
    }

    componentDidMount() {
        this.interval = setInterval(() => this.tick(), 1000);
    }

    componentWillUnmount() {
        clearInterval(this.interval);
    }

    render() {
        return (
            <div id='time_value' className='value bkColor3'>
                {('00' + this.state.minutes).slice(-2)}:{('00' + this.state.seconds).slice(-2)}
            </div>
        );
    }
}